import React, { useState } from 'react';
import { Tabs } from 'components/brikks/home/MovingOut/components/MovingOutModal/components/MovingOutInfo/components/Tabs';
import { Menus } from 'components/brikks/home/MovingOut/components/MovingOutModal/components/MovingOutInfo/components/Menus';
import { MenuContent } from 'components/brikks/home/MovingOut/components/MovingOutModal/components/MovingOutInfo/components/MenuContent';
import { Grid } from 'components/layout/Grid';
import { Brikk } from 'components/Brikk';
import { CheckListOptions, GeneralInfoOptions } from 'components/brikks/home/MovingOut/components/MovingOutModal/tabOptions';

export const MovingOutInfo = () => {
  const [activeTab, setActiveTab] = useState('checkList');
  const isCheckList = activeTab === 'checkList';

  return (
    <>
      <Grid.Column justifySelf="center">
        <Brikk.Heading
          heading="overview"
        >
          <Tabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

          <Menus
            menus={isCheckList ? CheckListOptions : GeneralInfoOptions}
            isCheckList={isCheckList}
          />
        </Brikk.Heading>
      </Grid.Column>

      <Grid.Column>
        <MenuContent />
      </Grid.Column>
    </>
  );
};
